export default __webpack_public_path__ + "static/media/menu_close.d5f5c54d.svg";